/*
 * Single entry point for turning a maker_checker_actions row into something renderable.
 *
 * Both adapters return the SAME shape, so the UI never needs to know which payload model
 * a row uses:
 *
 *   [{ table: "advertisers", rows: [{ field, before, after }, ...] }, ...]
 *
 * Retiring v0 is a one-line change here plus deleting legacyPayloadAdapter.js.
 */
import { isKeyedPayload } from "./constants";
import { buildKeyedGroups } from "./keyedPayloadAdapter";
import { buildLegacyGroups } from "./legacyPayloadAdapter"; // v0 — remove with the branch below

export const buildComparisonGroups = (action) => {
  if (!action) return [];
  // ---- v0 branch: delete this (and the import above) once no legacy rows remain ----
  if (!isKeyedPayload(action)) return buildLegacyGroups(action);
  // ---------------------------------------------------------------------------------
  return buildKeyedGroups(action);
};
